import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import ResponsiveImage from '../../../components/responsive-image'
import productCategorySelect from '../../../helpers/analytics-utils/product-category-select'
import style from './index.scss'

const TopRowCategory = ({ id, name, link, image, alt }) => (
  <div className={classNames(style.category, style.categoryTop)}>
    <Link
      className={style.categoryLink}
      to={link}
      onClick={() => productCategorySelect(id, name)}
    >
      <div className={style['overlay']} date-test-id="category-overlay" />
      <ResponsiveImage
        desktopImageUrl={image}
        mobileImageUrl={image}
        mobileRatio="poster"
        desktopRatio="poster"
        alt={alt}
        numberOfItems={3}
      />
      <h2 className={classNames(style.categoryHeader, style.categoryHeaderTop)}>
        {name}
      </h2>
    </Link>
  </div>
)

TopRowCategory.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default TopRowCategory
